const _jsxFileName = "C:\\Users\\sz\\Code\\openinc-projects\\ride-sharing-app\\app\\js\\ride-sharing-app\\components\\RideSearchResults.tsx";import React from "react";
import { RideSearchResultsDefault } from "..";

export function RideSearchResults({}) {
  return React.createElement(RideSearchResultsDefault, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 5}} );
}
